export default __webpack_public_path__ + "static/media/social-compliance-policy-updated.9444d681.pdf";